import React, { useState } from 'react';
import  { useFetchMyPage } from '../../hooks/useFetchData';
import MainLayout from '../../components/layouts/MainLayout';
import Breadcrumb from '../../components/shared/Breadcrumbs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard, faToggleOn, faToggleOff} from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from 'react-router-dom';
import PostForm from '../../components/shared/PostForm';
import * as Yup from 'yup';
import Modal from '../../components/ui/Modal';
import useModal from '../../hooks/useModal'

const MyPage = () => {
  const { data: mypage, loading, error } = useFetchMyPage(); 
  const navigate = useNavigate();
  const { isOpen, openModal, closeModal } = useModal();
  const [currentPage, setCurrentPage] = useState("");
  const [initialValues, setInitialValues] = useState(null);
  const backUrl = process.env.REACT_APP_API_URL;

  // お気に入り削除、投稿削除、投稿公開変更の関数
  const handleApiClick = async (url, type, id) => {
    const token = localStorage.getItem('token');
    let model
    if (type === "sharehouse") {
      model = "Sharehouse"
    } else if (type === "transaction") {
      model = "Transaction"
    } else {
      model = "Job"
    }
    if (token){
      try {
        let bodyData = {};
        if (type !== "delete_user") {
          bodyData = { model: model, post_id: id };
        }
        const response = await fetch(`${backUrl}${url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`, 
          },
          body: JSON.stringify(bodyData),
        });
        if (response.ok) {
          if (url === '/api/change_public/') {
            window.location.reload();
          } else if (url === '/api/delete_user/') {
            window.location.href = '/';
          }
        } else {
          console.error('Failed to add favorite:', response.statusText);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }else{
      console.log("ログインしてください")
    }
  };

  const handleDelete = (id, type) => {
    const element = document.getElementById(`p-${type}-${id}`);
    if (element) {
      element.remove();
    }
    const url = '/api/delete_post/';
    handleApiClick(url, type, id);
  };
  const handleFavoriteDelete = (id, type) => {
    const element = document.getElementById(`f-${type}-${id}`);
    if (element) {
      element.remove();
    }
    const url = '/api/delete_favorite/';
    handleApiClick(url, type, id);
  }
  
  const handleChange = (id, type) => {
    const url = '/api/change_public/';
    handleApiClick(url, type, id);
  }
  const handleDeleteUser = (id, type) => {
    const url = '/api/delete_user';
    handleApiClick(url, type, id);
  }


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading jobs: {error.message}</p>;

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userid');

    window.location.href = `${backUrl}/api/logout`;
  };

  const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "Mypage", path: "/mypage" },
  ];

  const hasPostData =
    (mypage.sharehouse && mypage.sharehouse.length > 0) ||
    (mypage.job && mypage.job.length > 0) ||
    (mypage.transaction && mypage.transaction.length > 0);
  
  const hasFavoriteData =
    (mypage.favorite_sharehouses && mypage.favorite_sharehouses.length > 0) ||
    (mypage.favorite_jobs && mypage.favorite_jobs.length > 0) ||
    (mypage.favorite_transactions && mypage.favorite_transactions.length > 0);

  // Formのための関数
  const formFields = {
    identification:[
      { name: 'ident-images', type: 'image', label: 'Driver LicenseまたはPassportの画像', description: '顔写真、フルネーム、生年月日が確認できるようにお願いいたします。'},
      { name: 'images', type: 'image', label: '顔写真(セルフティー)', description: '顔がはっきりわかる現在の顔写真のアップをお願いいたします'},
      { name: 'fullname', type: 'text', label: '名前(フルネーム)', placeholder: '名前を入力してください', validation: Yup.string().required('必須項目です') },
      { name: 'birthday', type: 'text', label: '生年月日', placeholder: '生年月日を入力してください', validation: Yup.string().required('必須項目です') },
      { name: 'number', type: 'text', label: 'ライセンス番号またはパスポート番号', placeholder: '番号を入力してください', validation: Yup.string().required('必須項目です') },
    ],
    userimage_form:[
      { name: 'images', type: 'image', label: '設定する画像を選択してください'},
    ],
    username_form:[
      { name: 'name', type: 'text', label: 'New User Name', placeholder: 'ユーザーネームを入力してください', validation: Yup.string().required('必須項目です') },
    ],
    mailladdress_form:[
      { name: 'email', type: 'text', label: 'New Email Address', validation: Yup.string().required('必須').email('正しいメールアドレス形式で入力してください'), validation: Yup.string().required('必須')},
    ],
    password_form:[
      { name: 'password', type: 'text', label: 'New Password', validation: Yup.string().required('必須').min(8, 'パスワードは最低8文字以上で入力してください')},
      { name: 'password_conf', type: 'text', label: 'New Password　(確認用)', validation: Yup.string().required('必須').oneOf([Yup.ref('password')], 'パスワードが一致しません')},
    ]
  }
  const type = currentPage

  const formConfig = {
    fields: formFields[currentPage] || []
  };

  const createPostForm = (formConfig, type, openModal, setCurrentPage, initialValues) => {
    return {
      title: '',
      formConfig: formConfig,
      type: type,
      apiUrl: { submit: `${backUrl}/api/identification/` },
      openModal: openModal,
      setCurrentPage: setCurrentPage,
      initialValues: initialValues || formConfig.fields.reduce((acc, field) => {
        acc[field.name] = field.initialValue || (field.type === 'checkbox' ? [] : '');
        return acc;
      }, {}),
    };
  };



  const post_form = createPostForm(formConfig, type, openModal, setCurrentPage, initialValues);

  return (
  <>
  <MainLayout>
    <Breadcrumb items={breadcrumbs} />
    <div className='mypage'>
      <div className='mypage__prof'>
        { mypage.image ?(
        <img src={`${backUrl}${mypage.image}`}/>
        ):mypage.line_image ?(
        <img src={`${mypage.line_image}`}/>
        ):(
        <img src="/media/none_user.svg"/>
        )}
        <div className='mypage__prof-flex'>
          <h3>{mypage.username}</h3>
          {/* {identification === true( */}
          <FontAwesomeIcon icon={faAddressCard} style={{color: "rgba(245, 149, 32, 1)",}} />
          {/* )} */}
        </div>
      </div>
      {mypage.identification === null ?(
        <div className='mypage__identification'>
          <span className='orange'>本人確認を完了してください</span>
          <p>本人未確認の場合$1000を超える取引はできません</p>
          <span onClick={() => { openModal(); setCurrentPage('identification') }}>本人確認をする</span>

        </div>
      ):mypage.identification === 0 ?(
        <div className='mypage__identification'>
          <span className='orange'>只今本人確認を行なっております</span>
          <p>完了するまで少々お待ちください</p>
        </div>
      ):(
        <div className='mypage__identification'>
          <span className='orange'>本人確認済み</span>
        </div>
      )}
      <div className='mypage__favorite'>
          <h3>お気に入り投稿一覧</h3>
          {hasFavoriteData ?( 
            <>
          { mypage.favorite_sharehouses && mypage.favorite_sharehouses.length > 0 ?(
          <div className='mypage__favorite-child'>
            <p>シェアハウス掲示板</p>
            <ul>
            {mypage.favorite_sharehouses.map((house) => (
              <li id={`f-sharehouse-${house.id}`} key={house.id} onClick={() => navigate(`/sharehouse/${house.id}`)}>
                { house.image && house.image.length > 0?(
                <img src={`${backUrl}${house.image}`} alt={house.title} width={200} />
                ):(
                <img src="/media/no-image.jpg" alt={house.title} width={200} />
                )}
                <span>{house.title}</span>
                <p className='green' onClick={(e) => {e.stopPropagation(); handleFavoriteDelete(house.id, "sharehouse");}}>削除</p>
              </li>
            ))}
            </ul>
          </div>
          ):(
            <></>
          )
          }
          {mypage.favorite_transactions && mypage.favorite_transactions.length > 0 ?(
          <div className='mypage__favorite-child'>
            <p>売買掲示板</p>
            <ul>
            {mypage.favorite_transactions.map((transaction) => (
              <li id={`f-transaction-${transaction.id}`} key={transaction.id} onClick={() => navigate(`/transaction/${transaction.id}`)}>
                { transaction.image ?(
                <img src={`${backUrl}${transaction.image}`} alt={transaction.title} width={200} />
                ):(
                <img src="/media/no-image.jpg" alt={transaction.title} width={200} />
                )}
                <span>{transaction.title}</span>
                <p className='green' onClick={(e) => {e.stopPropagation(); handleFavoriteDelete(transaction.id, "transaction");}}>削除</p>
              </li>
            ))}
            </ul>
          </div>
          ):(
            <></>
          )
          }
          { mypage.favorite_jobs && mypage.favorite_jobs.length > 0 ?(
          <div className='mypage__favorite-child'>
            <p>求人情報掲示板</p>
            <ul>
            {mypage.favorite_jobs.map((job) => (
              <li id={`f-job-${job.id}`} key={job.id} onClick={() => navigate(`/job/${job.id}`)}>
                { job.image ?(
                  <img src={`${backUrl}${job.image}`} alt={job.title} width={200} />
                ):(
                  <img src="/media/no-image.jpg" alt={job.title} width={200} />
                )}
                <span>{job.title}</span>
                <p className='green' onClick={(e) => {e.stopPropagation(); handleFavoriteDelete(job.id, "job");}}>削除</p>
              </li>
            ))}
            </ul>
          </div>
          ):(
            <></>
          )
          }
          </>
          ):(
          <p>お気に入りの投稿はありません</p>
          )}
      </div>
      <div className='mypage__pastpost'>
        <h3>過去の投稿一覧</h3>
        { hasPostData ?(
          <ul>
          { mypage.sharehouse &&
            <>
            {mypage.sharehouse.map((post) =>(
              <li id={`p-sharehouse-${post.id}`} key={post.id} onClick={() => navigate(`/sharehouse/${post.id}`)}>
                <span>{post.title}</span>
                <div className='mypage__pastpost-operation'>
                <span onClick={(e) => {e.stopPropagation(); handleChange(post.id, "sharehouse");}} >
                {post.public === true ?(
                  <FontAwesomeIcon icon={faToggleOn} style={{color: "#015b02",}} />
                ):(
                  <FontAwesomeIcon icon={faToggleOff} style={{color: "#015b02",}}/>
                )}
                </span>
                <p className='green' onClick={(e) => { e.stopPropagation(); navigate(`/sharehouse_post/?id=${post.id}`);}}>編集</p>
                <p className='green' onClick={(e) => {e.stopPropagation(); handleDelete(post.id, "sharehouse");}}>削除</p>
                </div>
              </li>
            ))}
            </>
          }
          { mypage.transaction &&
            <>
            {mypage.transaction.map((post) =>(
              <li id={`p-transaction-${post.id}`} key={post.id} onClick={() => navigate(`/transaction/${post.id}`)}>
                <span>{post.title}</span>
                <div className='mypage__pastpost-operation'>
                <span onClick={(e) => {e.stopPropagation(); handleChange(post.id, 'transaction');}}>
                {post.public === true ?(
                  <FontAwesomeIcon icon={faToggleOn} style={{color: "#015b02",}} />
                ):(
                  <FontAwesomeIcon icon={faToggleOff} style={{color: "#015b02",}}/>
                )}
                </span>
                <p className='green' onClick={(e) => { e.stopPropagation(); navigate(`/transaction_post/?id=${post.id}`);}}>編集</p>
                <p className='green' onClick={(e) => {e.stopPropagation(); handleDelete(post.id, 'transaction');}}>削除</p>
                </div>
              </li>
            ))}
            </>
          }
          { mypage.job &&
            <>
            {mypage.job.map((post) =>(
              <li id={`p-job-${post.id}`} key={post.id} onClick={() => navigate(`/job/${post.id}`)}>
                <span>{post.title}</span>
                <div className='mypage__pastpost-operation'>
                <span onClick={(e) => {e.stopPropagation(); handleChange(post.id, "job");}}>
                {post.public === true ?(
                  <FontAwesomeIcon icon={faToggleOn} style={{color: "#015b02",}} />
                ):(
                  <FontAwesomeIcon icon={faToggleOff} style={{color: "#015b02",}}/>
                )}
                </span>
                <p className='green' onClick={(e) => { e.stopPropagation(); navigate(`/job_post/?id=${post.id}`);}}>編集</p>
                <p className='green' onClick={(e) => {e.stopPropagation(); handleDelete(post.id, 'job');}}>削除</p>
                </div>
              </li>
            ))}
            </>
          }
          </ul>
        ):(
          <p>過去の投稿はありません</p>
        )}
      </div>
      <div className='mypage__pastpost'>
        <h3>ユーザー設定</h3>
        <ul>
          <li onClick={() => { openModal(); setCurrentPage('userimage_form') }}>ユーザー画像変更</li>
          <li onClick={() => { openModal(); setCurrentPage('username_form') }}>ユーザーネーム変更</li>
          {mypage.line_user === false ?(
            <>
            <li onClick={() => { openModal(); setCurrentPage('mailladdress_form') }}>メールアドレス変更</li>
            <li onClick={() => { openModal(); setCurrentPage('password_form') }}>パスワード変更</li>
            </>
          ):null}
          <li onClick={() => { openModal(); setCurrentPage('user_delete_conf') }}>退会する</li>
        </ul>
      </div>
      <div className='mypage__logout'>
        <button className='btn-white button' type="button" onClick={handleLogout}>logout</button>
      </div>
    </div>  
  </MainLayout>
  <Modal 
    isOpen={isOpen} 
    closeModal={closeModal} 
    currentPage={currentPage} 
    setCurrentPage={setCurrentPage} 
    className="login"
  >
  {currentPage === "userimage_form"?(
    <PostForm {...post_form} />
  ):currentPage === "username_form"?(
    <PostForm {...post_form} />
  ):currentPage === "mailladdress_form"?(
    <PostForm {...post_form} />
  ):currentPage === "password_form"?(
    <PostForm {...post_form} />
  ):currentPage === "identification" ? (
    <>
      <h2 className='login__ttl'>本人確認フォーム</h2>
      <div className='signup__form'>
      <PostForm {...post_form} />
      </div>
    </>
  ):currentPage === "identification_comp" ? (
      <>
      <div className='post__comp'>
        <h3>送信しました</h3>
        <span>審査状況はマイページよりご確認いただけます。</span>
        <span>$1000以上の投稿をされている方は審査終了後にMY PAGEより公開設定をお願いいたします。</span>
        <p>審査が完了するまでしばらくお待ちください</p>
        <a href='/mypage'>MY PAGE</a>
      </div>
      </>
  ):currentPage === "user_edition_comp" ?(
    <>
      <div className='post__comp'>
        <h3>編集が完了いたしました</h3>
        <span>引き続きGold Coast Koalaをお楽しみください</span>
        <a href='/mypage'>MY PAGE</a>
      </div>
      </>
  ):currentPage === "user_delete_conf" ?(
    <>
      <div className='post__comp'>
        <h3>ユーザー情報を削除します、本当に宜しいですか？</h3>
        <p>ユーザー情報を削除すると、投稿やチャット履歴、その他関連情報は全て失われます。</p>
        <p onClick={handleDeleteUser(0, 'user_delete')} className='post__comp-delete'>削除する</p>
      </div>
    </>
  ): null }
  </Modal>
  </>
  )
};

export default MyPage;


<div style="
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  width: 259px;
  background: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: -2px 10px 5px rgba(0, 0, 0, 0);
  border-radius: 10px;
  font-family: SQ Market, SQ Market, Helvetica, Arial, sans-serif;
  ">
  <div style="padding: 20px;">
    <a target="_blank" href="https://square.link/u/rClgdHtq?src=embed" style="
    display: inline-block;
    font-size: 18px;
    line-height: 48px;
    height: 48px;
    color: #ffffff;
    min-width: 212px;
    background-color: #006aff;
    text-align: center;
    box-shadow: 0 0 0 1px rgba(0,0,0,.1) inset;
    border-radius: 6px;
  ">今すぐ購入する</a>
  </div>
</div>